import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M12 7h1.5v6.5H8V12h4z" }), /* @__PURE__ */ _jsx("path", { d: "M3 12c0-4.968 4.032-9 9-9s9 4.032 9 9-4.032 9-9 9-9-4.032-9-9m1.8 0c0 3.969 3.231 7.2 7.2 7.2s7.2-3.231 7.2-7.2-3.231-7.2-7.2-7.2S4.8 8.031 4.8 12" })]
});
export default SvgHistory;
